module.exports = __webpack_public_path__ + "static/img/10.7918de2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/3/sp/10.png
// module id = Z07B
// module chunks = 0